import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpParams} from '@angular/common/http';
import {Merchant} from './model';
import {RestClientService} from './rest-client/rest-client.service';
import {Count} from './model/count';

@Injectable({
  providedIn: 'root'
})
export class MerchantService {

  constructor(private restClient: RestClientService) {
  }

  public findByNameMatchingText(text: string): Observable<Merchant[]> {
    const params = new HttpParams().append('text', text);
    return this.restClient.getWithParams<Merchant[]>(`/merchants`, params);
  }

  public getLocationsCount(merchantId: string, stateId?: string | null, cityId?: string | null): Observable<Count> {
    let params = new HttpParams();

    if (stateId) {
      params = params.append('stateId', stateId);
    }

    if (cityId) {
      params = params.append('cityId', cityId);
    }

    return this.restClient.getWithParams<Count>(`/merchants/${merchantId}/locations/count`, params);
  }
}
